module.exports = __webpack_public_path__ + "static/img/3_2_2_1.b3219b4b.jpg";